<mat-tab-group (selectedTabChange)="onChange($event)" #tabGroup class="edi-tabs-wrapper" mat-stretch-tabs="false"
  mat-align-tabs="start" [selectedIndex]="0">
  <mat-tab label="Reports">

<div id="reports-main-wraper">
  <div class="col-12 search-ft p-0 mt-3">
    <div class="row align-items-start justify-content-start">
      <div class="col-2">
        <div class="form-group mb-0" style="position:relative;">
          <label name="lblPRFileType" class="control-label required">File Type </label>
          <select name="ddPRFileType" class="form-control" [(ngModel)]="selectedFileType.id"
            (change)="fileTypeSelectChanged($event)" tabindex="2">
            <option value="0" selected> --- Select File Type --- </option>
            <option *ngFor="let fileType of fileTypes" [ngValue]="fileType.id">{{fileType.name}}</option>
          </select>
          <div class="lblerror" style="position:absolute; font-size: 13px; white-space:nowrap;">
            {{ this.lblErrorFileType }}
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group mb-0">
          <div class="input-group">
            <label class="control-label col-12 p-0" name="lblPRUploadFrmDt">
              Uploaded From Date </label>
            <input class="form-control" placeholder="Select From Date" name="dpPRFrmDt" ngbDatepicker
              [(ngModel)]="dpPRFrmDate" #d1="ngbDatepicker">
            <div class="input-group-append dtToggle">
              <button class="btn btn-outline-secondary calendar" type="button" (click)="d1.toggle()" tabindex="4">
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2">
        <div class="form-group mb-0">
          <div class="input-group">
            <label class="control-label col-12 p-0" name="lblPRUploadToDt">
              Uploaded To Date </label>
            <input class="form-control" placeholder="Select To Date" name="dpPRToDt" ngbDatepicker
              [(ngModel)]="dpPRToDate" #d2="ngbDatepicker">
            <div class="input-group-append dtToggle">
              <button class="btn btn-outline-secondary calendar" type="button" (click)="d2.toggle()" tabindex="5">
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-auto">
        <div class="form-group mb-0">
          <button class="btn btn-primary mr-2" name="btnPRSearch" (click)="getGridDataByFilterSearch()"
            tabindex="6">Search</button>
          <button class="btn btn-outline-primary mr-2" name="btnPRReset" (click)="onResetFilters()"
            tabindex="7">Reset</button>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex justify-content-end mt-2 mb-1">
    <div id="gridActions">
      <label class="mr-2" name="lblPRExport" (click)="exportExcel()" tabindex="7"><span>
          <em class="fas fa-file-download"></em></span> Export</label>
    </div>
  </div>
  <div class="mt-1">
    <ag-grid-angular #agGridReports [enableCellTextSelection]="true" class="ag-theme-material provision-layout"
      [rowData]="rowData" [columnDefs]="columnDefs" [gridOptions]="gridOptions"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
</div>

  </mat-tab>

  <mat-tab label="XML Process Status">
    <app-xml-process-status></app-xml-process-status>
  </mat-tab>

</mat-tab-group>